<template>
    <div class="search" :style="boxStyle">
<!--    <div class="search" :style="boxStyle" v-drag>-->
        <a-select
            show-search
            :value="value"
            placeholder="输入名称进行搜索"
            :style="inputStyle"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            @search="handleSearch"
            @change="handleChange"
            :showArrow="true"
        >
            <a-select-option v-for="d in data" :key="d.value">
                {{ d.text }}
            </a-select-option>
        </a-select>
        <div class="search-btn" @click="toggleInput"></div>
    </div>
</template>

<script>
/* eslint-disable */
import {getFuzzyApi} from "@/api/visualization";

let timeout
let currentValue
import {ref} from 'vue'
export default {
    name: "searchBox",
    setup() {
        const value = ref(undefined)
        const data = ref([])
        const inputStyle = ref('width: 400px;margin-left: 5px;display: none')
        const boxStyle = ref('')
        const status = ref(false)
        return {
            value,
            data,
            inputStyle,
            boxStyle,
            status
        }
    },
    methods: {
        toggleInput() {
            if (this.status) {
                this.status = false
                this.inputStyle = 'display: none'
                this.boxStyle = 'width: 80px'
            } else {
                this.status = true
                this.inputStyle = 'width: 400px;margin-left: 5px;display: block'
                this.boxStyle = 'width: 489px'
            }
        },
        fetch(value, callback) {
            const that = this
            if (timeout) {
                clearTimeout(timeout)
                timeout = null
            }
            currentValue = value
            function fake() {
                value  = value.replace(/\s*/g,"")
                if (value) {
                    const townId = that.$parent.townId !== '0' ? that.$parent.townId : '0'
                    getFuzzyApi(townId + '/' + value).then(d => {
                        if (currentValue === value) {
                            let result
                            if (d) {
                                if (d.length > 10) {
                                    result = d.splice(0, 9)
                                } else {
                                    result = d
                                }
                            } else {
                                result = []
                            }
                            const data = []
                            if (result) {
                                result.forEach(r => {
                                    data.push({
                                        value: r.id+',' + r.coordinate,
                                        text: r.name,
                                    })
                                })
                            }
                            callback(data)
                        }
                    })
                }

            }
            timeout = setTimeout(fake, 300)
        },
        handleSearch(value) {
            this.fetch(value, data => (this.data = data));
        },
        handleChange(value) {
            let lonLat = value.split(',')
            if (lonLat[1] === null || lonLat[2] === null) {
                return
            }
            const lonLats = {
                lon: parseFloat(lonLat[1]),
                lat: parseFloat(lonLat[2]),
                height: 300
            }
            this.$parent.moveCamera(lonLats)
            this.value = value
            this.fetch(value, data => (this.data = data))
        },
    }
}
</script>

<style scoped lang="stylus">
    .search {
        max-width 489px
        height 80px
        overflow hidden
        position fixed
        right 535px
        bottom 25px
        z-index 3
        display flex
        border 2px solid #01EFDC
        border-radius 52px
        transition 0.3s
        .search-btn {
            width 80px
            height 80px
            background-image url("../../assets/img/search.png")
            background-size 100% 100%
            cursor pointer
            transition .5s
        }
        .search-btn:hover {
            transform rotate(42deg)
        }
        /deep/ .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
            width 100%
            height 76px
            line-height 76px
            background none
            border none
        }
        /deep/ .ant-select-selection-search-input {
            width 100%
            height 76px
            line-height 76px
            color #19ecd8
            font-size 22px
        }
        /deep/ .ant-select-selection-item {
            width 100%
            height 76px
            line-height 76px
            color #19ecd8
            font-size 22px
        }
        /deep/ .ant-select-selection-placeholder {
            width 100%
            height 76px
            line-height 76px
            color #19ecd8
            font-size 22px
        }

    }
    @media (min-width: 1921px) {
        .search {
            right 735px
        }
    }
</style>